import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ExpenditureCategoryListComponent } from './list/list.component';
import { AuthGuard } from '../auth/auth.guard';
import { ExpenditureCategoryService } from './expenditure-category.service';
import { SharedModule } from '../shared/shared.module';
import { ExpenditureCategoryCreateComponent } from './create/create.component';
import { ExpenditureCategoryFormComponent } from './form/form.component';
import { ExpenditureCategoryEditComponent } from './edit/edit.component';

const routes: Routes = [
  {
    path: 'expenditure-categories',
    component: ExpenditureCategoryListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'expenditure-categories/create',
    component: ExpenditureCategoryCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'expenditure-categories/:id/edit',
    component: ExpenditureCategoryEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    ExpenditureCategoryListComponent,
    ExpenditureCategoryCreateComponent,
    ExpenditureCategoryFormComponent,
    ExpenditureCategoryEditComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, ExpenditureCategoryService],
})
export class ExpenditureCategoryRoutingModule {}
